import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import VSLPlayer from "@/components/VSLPlayer";

const TEASER_LOOP_SRC = "/ai_ops_vsl_preview.mp4";
const YOUTUBE_VIDEO_ID = "E4QHoHm0HDc";

const Hero = () => {
  return (
    <section className="relative pt-24 pb-8 lg:pt-32 lg:pb-12 overflow-hidden">
      {/* Background atmosphere — soft gradient + subtle pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-secondary via-background to-background" />
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%231A365D' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      />

      <div className="section-container relative z-10">
        <div className="max-w-2xl lg:max-w-4xl mx-auto text-center">
          {/* Main headline */}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-serif leading-tight mb-2 lg:mb-3 lg:whitespace-nowrap">
            Expand Your{" "}
            <span className="relative inline-block">
              <span className="relative z-10">Margins</span>
              <span className="absolute bottom-1 lg:bottom-2 left-0 right-0 h-3 bg-gold/25 -z-0" />
            </span>{" "}
            With AI
          </h1>

          {/* Subhead */}
          <p className="text-lg sm:text-xl lg:text-2xl text-body-gray leading-relaxed mb-4 lg:mb-5 max-w-2xl mx-auto">
            AI systems that cut costs and lift revenue
          </p>

          {/* Trustpilot strip — hidden until Trustpilot Pro widget is added.
              When restoring, wrap the widget in:
                <a href="https://www.trustpilot.com/review/wolf-cto.com"
                   target="_blank" rel="noopener noreferrer"
                   className="inline-block cursor-pointer mb-6">
                  ...widget at h-8 sm:h-10 w-auto mx-auto...
                </a> */}

          {/* VSL with ambient glow */}
          <div className="relative mb-12 max-w-xl mx-auto">
            {/* Ambient halo — symmetric navy→gold bleed centered on the player */}
            <div
              aria-hidden="true"
              className="pointer-events-none absolute -inset-x-20 -inset-y-16 sm:-inset-x-32 sm:-inset-y-24 -z-10"
              style={{
                background:
                  "radial-gradient(70% 30% at 50% 50%, hsl(var(--navy) / 0.85) 0%, hsl(var(--gold) / 0.45) 50%, transparent 80%)",
                filter: "blur(70px)",
              }}
            />
            <div className="relative">
              <VSLPlayer
                videoId={YOUTUBE_VIDEO_ID}
                teaserSrc={TEASER_LOOP_SRC}
              />
            </div>
          </div>

          {/* CTA */}
          <div>
            <Button
              variant="gold"
              size="xl"
              className="text-white font-bold bg-gradient-to-br from-gold to-orange-400 hover:from-gold-dark hover:to-orange-500"
              asChild>
              <Link to="/get-started">Get Started</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
